import styled from 'styled-components';

export const TableCell = styled.td``;
